module.exports = __webpack_public_path__ + "img/thumb.e91dca29.jpeg";